/**
 * Feature flags del portal.
 *
 * Hoy los valores se definen manualmente en DEFAULT_FEATURE_FLAGS.
 * Cuando el backend los envíe en GET /v1/core/portal/profile/status
 * (propiedad `featureFlags` del AccountStatus), el valor del backend
 * pisa al default del front. Si el backend no envía un flag (o no es boolean),
 * se usa el default.
 *
 * Ejemplo de respuesta esperada del backend:
 *   { ..., "featureFlags": { "echeqLoadById": false } }
 */
export interface FeatureFlags {
  /** Habilita la carga de e-cheqs por ID (tarjeta "Cargar con ID" y su pantalla). */
  echeqLoadById: boolean;
}

/** Valores manuales del front. Cambiar acá para activar/desactivar mientras el backend no lo envíe. */
export const DEFAULT_FEATURE_FLAGS: Readonly<FeatureFlags> = {
  echeqLoadById: false,
};

/** Combina los defaults del front con lo que venga del backend (el backend tiene prioridad). */
export function resolveFeatureFlags(fromBackend?: Partial<FeatureFlags> | null): FeatureFlags {
  const resolved: FeatureFlags = { ...DEFAULT_FEATURE_FLAGS };
  if (!fromBackend) {
    return resolved;
  }
  (Object.keys(DEFAULT_FEATURE_FLAGS) as (keyof FeatureFlags)[]).forEach((key) => {
    const value = fromBackend[key];
    if (typeof value === "boolean") {
      resolved[key] = value;
    }
  });
  return resolved;
}
